export default {
  reminderTime: 'زمان یادآوری',
  custom: 'سفارشی',
  selectCustomTime: 'انتخاب زمان سفارشی',
  confirm: 'تأیید',
  count: 'تعداد',
  type: 'نوع',
  minute: 'دقیقه',
  hour: 'ساعت',
  day: 'روز',
  week: 'هفته',
  negativeNumbersMeansAgoAndPositiveNumbersMeansLater:
    'عدد منفی به معنای زمان قبل و عدد مثبت به معنای زمان بعد است.',
  halfHourAgo: 'ربع ساعت قبل',
  quarterHourAgo: 'نیم ساعت قبل',
  oneHourAgo: 'یک ساعت قبل',
  oneDayAgo: 'یک روز قبل',
  threeDaysAgo: 'سه روز قبل',
  oneWeekAgo: 'یک هفته قبل',
  oneHourLater: 'یک ساعت بعد',
  oneDayLater: 'یک روز بعد',
  makeReminderReadable(reminder: number) {
    let agoOrLater = 'بعد';
    if (reminder < 0) {
      agoOrLater = 'قبل';
      reminder *= -1;
    }
    if (0 <= reminder && reminder < 60) {
      return `${reminder} دقیقه ${agoOrLater}`;
    } else if (60 <= reminder && reminder < 1440) {
      const msg = `${Math.round(reminder / 60)} ساعت ${agoOrLater}`;
      if (isFloat(reminder / 60)) {
        return `حدود ${msg}`;
      }
      return msg;
    } else if (1440 <= reminder && reminder < 10080) {
      const msg = `${Math.round(reminder / 1440)} روز ${agoOrLater}`;
      if (isFloat(reminder / 1440)) {
        return `حدود ${msg}`;
      }
      return msg;
    } else if (reminder >= 10080) {
      const msg = `${Math.round(reminder / 10080)} هفته ${agoOrLater}`;
      if (isFloat(reminder / 10080)) {
        return `حدود ${msg}`;
      }
      return msg;
    } else {
      return reminder;
    }
  },
};

function isFloat(x: number) {
  return !!(x % 1);
}
